import { ProcessInstanceInfoModel } from './process-instance-info.model';
export declare class ProcessInfoModel {
  size: number;
  total: number;
  start: number;
  data: ProcessInstanceInfoModel[];
  constructor(obj?: any);
}

export interface ProcessPrimaryFilterCard {
  label: string;
  value: number;
}

export interface ProcessPrimaryFilterParams {
  param: string;
  label: string;
}

export interface ProcessPrimaryFilterModel {
  allCount: number;
  activeCount: number;
  completedCount: number;
  canceledCount: number;
}

export class CancelProcessAttachmentModel {
  attachmentName: string;
  checkedout: boolean;
  checkedoutOwner: {
    displayName: string;
  };
  constructor(
    attachmentName?: string,
    checkedout = false,
    checkedoutOwner?: {
      displayName: string;
    }
  ) {
    this.attachmentName = attachmentName;
    this.checkedout = checkedout;
    this.checkedoutOwner = checkedoutOwner;
  }
}

export class CancelProcessModel {
  processInstance: string;
  cancelReason: string;
  attachments: Array<CancelProcessAttachmentModel>;
  constructor(
    processInstance?: string,
    cancelReason = '',
    attachments?: Array<CancelProcessAttachmentModel>
  ) {
    this.processInstance = processInstance;
    this.cancelReason = cancelReason;
    this.attachments = attachments;
  }
}

export declare class CancelProcessInstanceResponse {
  cancelledProcessInstances: Array<string>;
  completedProcessInstances: Array<string>;
  message: string;
  constructor(obj?: any);
}

export interface Users {
  email: string;
  firstName: string;
  id: number;
  lastName: string;
}

export interface ProcessFilterData {
  processId?: number;
  attachmentName?: string;
  userMailId?: number;
}
